// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card[data-v-4a4c6290]{border:none;border-radius:0;height:100vh;height:calc(var(--vh, 1vh)*100);padding:0;top:0;z-index:1000}.card .login-footer .divider[data-v-4a4c6290]{border:1px solid #8c8b8c;width:25%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
